// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.alert-modal {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 90%;
  text-align: center;
  position: relative;
  z-index: 10000;
}

.alert-modal p {
  margin: 0 0 20px 0;
  font-size: 16px;
}

.alert-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.alert-modal-button {
  padding: 8px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.alert-modal-button.confirm {
  background-color: #4CAF50;
  color: white;
}

.alert-modal-button.confirm:hover {
  background-color: #45a049;
}

.alert-modal-button.cancel {
  background-color: #f44336;
  color: white;
}

.alert-modal-button.cancel:hover {
  background-color: #da190b;
}

.alert-modal-button:not(.confirm):not(.cancel) {
  background-color: #2196F3;
  color: white;
}

.alert-modal-button:not(.confirm):not(.cancel):hover {
  background-color: #1976D2;
}

.success {
  color: #4CAF50;
}

.failure {
  color: #f44336;
}

.warning {
  color: #6616CD;
}

.alert-image {
  width: 100%;
  height: auto;
  vertical-align: top;
}

.buttonPurple {
  background: none;
  border: none;
  color: #6616cd;
}`, "",{"version":3,"sources":["webpack://./src/components/AlertBox/AlertBox.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".alert-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.alert-modal {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  max-width: 400px;\n  width: 90%;\n  text-align: center;\n  position: relative;\n  z-index: 10000;\n}\n\n.alert-modal p {\n  margin: 0 0 20px 0;\n  font-size: 16px;\n}\n\n.alert-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.alert-modal-button {\n  padding: 8px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.alert-modal-button.confirm {\n  background-color: #4CAF50;\n  color: white;\n}\n\n.alert-modal-button.confirm:hover {\n  background-color: #45a049;\n}\n\n.alert-modal-button.cancel {\n  background-color: #f44336;\n  color: white;\n}\n\n.alert-modal-button.cancel:hover {\n  background-color: #da190b;\n}\n\n.alert-modal-button:not(.confirm):not(.cancel) {\n  background-color: #2196F3;\n  color: white;\n}\n\n.alert-modal-button:not(.confirm):not(.cancel):hover {\n  background-color: #1976D2;\n}\n\n.success {\n  color: #4CAF50;\n}\n\n.failure {\n  color: #f44336;\n}\n\n.warning {\n  color: #6616CD;\n}\n\n.alert-image {\n  width: 100%;\n  height: auto;\n  vertical-align: top;\n}\n\n.buttonPurple {\n  background: none;\n  border: none;\n  color: #6616cd;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
